import React, { useEffect, useRef } from 'react';
import imagen from "../images/tapiz.png";

const Back = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    const cssString = `
      @import url('https://fonts.googleapis.com/css2?family=Spartan:wght@400;700&display=swap');
      @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;700&display=swap');

      body, html {
        margin: 0;
        padding: 0;
        overflow: hidden;
        font-family: 'Spartan', sans-serif;
        height: 100%;
        background-image: url('${imagen}');
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
      }

      .gradient-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(ellipse at center, transparent, rgba(0, 0, 0, 0.4) 80%);
        pointer-events: none;
        z-index: 1;
      }

      .instagram-logo {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 50px;
        cursor: pointer;
        z-index: 2;
      }

      .quote {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -60%); /* Ajustado para no solaparse con el logo */
        color: white;
        font-family: 'Spartan', sans-serif;
        text-align: center;
        width: 70%; /* Ajusta según necesidad */
        font-size: 20px; /* Ajusta según necesidad */
        z-index: 2;
      }

      .citation {
        position: absolute;
        bottom: 10%; /* Ajusta según necesidad */
        right: 10%; /* Ajusta según necesidad */
        color: #ccc; /* Color suave para la cita */
        font-family: 'Open Sans', sans-serif;
        font-size: 16px; /* Ajusta según necesidad */
        z-index: 2;
      }
    `;

    const styleEl = document.createElement("style");
    styleEl.textContent = cssString;
    iframeDoc.head.appendChild(styleEl);

    const gradientOverlay = document.createElement("div");
    gradientOverlay.className = 'gradient-overlay';
    iframeDoc.body.appendChild(gradientOverlay);

    const quoteDiv = document.createElement("div");
    quoteDiv.className = 'quote';
    quoteDiv.innerHTML = `"La pregunta de si una computadora puede pensar no es más interesante que la pregunta de si un submarino puede nadar."`;
    iframeDoc.body.appendChild(quoteDiv);

    const citationDiv = document.createElement("div");
    citationDiv.className = 'citation';
    citationDiv.innerHTML = `— Edsger Dijkstra`;
    iframeDoc.body.appendChild(citationDiv);

  }, []);

  return <iframe ref={iframeRef} style={{ width: '100%', height: '100%', position: 'relative' }} title="Iframe Instagram Link"></iframe>;
};

export default Back;
